import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, NavigationService } from '@spartacus/storefront';
import { KnBrFooterComponent } from 'src/app/common/kn-br-footer/kn-br-footer.component';
import { AtgContactUsDialogComponent } from '../atg-contact-us-dialog/atg-contact-us-dialog.component';
import { KnBrNavigationService } from 'src/services/kn-br-navigation.service';

@Component({
  selector: 'atg-footer',
  templateUrl: './atg-footer.component.html',
  styleUrl: './atg-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AtgFooterComponent extends KnBrFooterComponent {
  constructor(
    protected override componentData: CmsComponentData<CmsNavigationComponent>,
    protected override service: NavigationService,
    protected knBrNavigationService: KnBrNavigationService,
    private modalService: NgbModal
  ) {
    super(componentData, service);
  }

  override get node$() {
    return this.knBrNavigationService.getNavigationNode(this.componentData.data$);
  }

  openContactUs(sendEmailTo: string = ''): void {
    const modalRef = this.modalService.open(AtgContactUsDialogComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.sendEmailTo = sendEmailTo;
  }
}
